/**
 * Canonical Material Icons for each app section.
 * Used by sidebar navigation AND page headers — keep in sync here only.
 */
export const NAV_ICONS = {
  dashboard: 'dashboard',
  contacts: 'contacts',
  bankAccounts: 'account_balance',
  bankTransactions: 'account_balance',
  inventory: 'inventory_2',
  invoices: 'receipt_long',
  quotes: 'request_quote',
  expenses: 'receipt',
  journalEntries: 'menu_book',
  bulkPayments: 'account_balance_wallet',
  transfers: 'swap_horiz',
  reports: 'assessment',
  taxPeriods: 'date_range',
  chartOfAccounts: 'account_tree',
  imageProcessing: 'document_scanner',
  businessManagement: 'business',
  settings: 'settings',
  superAdmin: 'admin_panel_settings',
  integrations: 'hub',
  voiceAssistant: 'mic',
  microphoneTest: 'mic',
} as const;

export type NavIconKey = keyof typeof NAV_ICONS;

/** Gradient backgrounds for page header icons — one per section */
export const NAV_ICON_GRADIENTS: Record<NavIconKey, string> = {
  dashboard: 'linear-gradient(135deg, #00c6ff 0%, #00b894 100%)',
  contacts: 'linear-gradient(135deg, #0096c7 0%, #1d4ed8 100%)',
  bankAccounts: 'linear-gradient(135deg, #0891b2 0%, #0284c7 100%)',
  bankTransactions: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
  inventory: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
  invoices: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
  quotes: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
  expenses: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
  journalEntries: 'linear-gradient(135deg, #d97706 0%, #b45309 100%)',
  bulkPayments: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
  transfers: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
  reports: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)',
  taxPeriods: 'linear-gradient(135deg, #64748b 0%, #475569 100%)',
  chartOfAccounts: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
  imageProcessing: 'linear-gradient(135deg, #0096c7 0%, #00b894 100%)',
  businessManagement: 'linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)',
  settings: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
  superAdmin: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
  integrations: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)',
  voiceAssistant: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  microphoneTest: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
};

export function getNavIcon(key: NavIconKey): string {
  return NAV_ICONS[key];
}

export function getNavIconGradient(key: NavIconKey): string {
  return NAV_ICON_GRADIENTS[key];
}
